module.exports = __webpack_public_path__ + "img/green-grad-wave.da41625c.png";